import React from 'react';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Row, Col } from 'reactstrap';

// const refreshPage = (e, examGroup, question, total?) => {
//   e.preventDefault();
//   const link = getViewExamLink(examGroup, question, total);
//   console.log(link);
//   window.location.replace(link);
//   setTimeout(() => window.location.reload(), 1000);
// };

export const CorrectAnswer = props => (
  <div>
    <span>Correct Answer : </span>
    <span>{props.question.solution} - { props.question[`answer_${props.question.solution.toLowerCase()}`]}</span>
  </div>
);

export const RadioElement = props => (
  <div className="custom-control custom-radio mb-3">
    <input
      className="custom-control-input"
      id= {`customRadio-${props.value}`}
      name={`custom-radio-${props.name}`}
      type="radio"
      defaultChecked = { props.answer === props.value ? true : false }
      disabled = { props.disabled }
      value= { props.value}
      onChange= { props.onChange }
    />
    <label
      className={`custom-control-label ${ props.disabled && props.value === props.solution ? "text-green" : ""}`}
      htmlFor= {`customRadio-${props.value}`}
    >
      { props.label }
    </label>
  </div>
);


export const RenderMultipleChoiceQuestion = props => {
  const { question, disabled } = props;
  return (<Row className="py-3 align-items-center">
      <Col md="12">
        <span className="mc-text" dangerouslySetInnerHTML={{ __html: props.question.text }} />
      </Col>
      <Col sm="12">
        { question.answer_a && <RadioElement solution={props.question.solution} name={props.name} answer={ props.answer } disabled={disabled} value="A" label= {question.answer_a} onChange={props.onChangeRadioValue } /> }
        { question.answer_b && <RadioElement solution={props.question.solution} name={props.name} answer={ props.answer } disabled={disabled} value="B" label= {question.answer_b} onChange={props.onChangeRadioValue } /> }
        { question.answer_c && <RadioElement solution={props.question.solution} name={props.name} answer={ props.answer } disabled={disabled} value="C" label= {question.answer_c} onChange={props.onChangeRadioValue } /> }
        { question.answer_d && <RadioElement solution={props.question.solution} name={props.name} answer={ props.answer } disabled={disabled} value="D" label= {question.answer_d} onChange={props.onChangeRadioValue } /> }
        { question.answer_e && <RadioElement solution={props.question.solution} name={props.name} answer={ props.answer } disabled={disabled} value="E" label= {question.answer_e} onChange={props.onChangeRadioValue } /> }
        { question.answer_f && <RadioElement solution={props.question.solution} name={props.name} answer={ props.answer } disabled={disabled} value="F" label= {question.answer_f} onChange={props.onChangeRadioValue } /> }
        { question.answer_g && <RadioElement solution={props.question.solution} name={props.name} answer={ props.answer } disabled={disabled} value="G" label= {question.answer_g} onChange={props.onChangeRadioValue } /> }
        { question.answer_h && <RadioElement solution={props.question.solution} name={props.name} answer={ props.answer } disabled={disabled} value="H" label= {question.answer_h} onChange={props.onChangeRadioValue } /> }
        { question.answer_i && <RadioElement solution={props.question.solution} name={props.name} answer={ props.answer } disabled={disabled} value="I" label= {question.answer_i} onChange={props.onChangeRadioValue } /> }
        { question.answer_j && <RadioElement solution={props.question.solution} name={props.name} answer={ props.answer } disabled={disabled} value="J" label= {question.answer_j} onChange={props.onChangeRadioValue } /> }
      </Col>
  </Row>)
};